import { useState, useEffect } from 'react';

import * as http from 'utils/http';
import config from 'config';

const useOfferStats = (journeyId) => {
  const [statsData, setStatsData] = useState(null);

  useEffect(() => {
    const fetchStatsForJourneyWithId = async (journeyId) => {
      try {
        const data = await http.get(
          config.API_URL + `mercury/offers/${journeyId}/latest_offer_stats/`
        );
        setStatsData(data);
      } catch (err) {
        console.error('Error fetching useOfferStats', err);
      }
    };
    fetchStatsForJourneyWithId(journeyId);
  }, [journeyId]);

  return statsData;
};

const useOfferAcceptedDrivers = (journeyId) => {
  const [loading, setLoading] = useState(true);
  const [drivers, setDrivers] = useState([]);

  useEffect(() => {
    const fetchAcceptedDrivers = async (journeyId) => {
      try {
        const data = await http.get(
          config.API_URL + `mercury/offers/${journeyId}/accepted_drivers/`
        );
        setDrivers(data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching useOfferAcceptedDrivers', err);
      }
    };
    fetchAcceptedDrivers(journeyId);
  }, [journeyId]);

  return { loading, drivers };
};

const usePostSelectedDrivers = (journeyId, driverIdList) => {
  const [posting, setPosting] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isOk, setIsOk] = useState(false);

  useEffect(() => {
    const postDriverIdsForOffer = async (journeyId, driverIdList) => {
      try {
        setPosting(true);
        await http.post(config.API_URL + `mobile/offers/`, {
          offer: { type: 'journey', id: journeyId },
          driver_ids: driverIdList,
        });
        setPosting(false);
        setIsError(false);
        setIsOk(true);
      } catch (err) {
        setPosting(false);
        setIsError(true);
        setIsOk(false);
      }
    };
    if (driverIdList.length && journeyId) {
      postDriverIdsForOffer(journeyId, driverIdList);
    }
  }, [journeyId, driverIdList]);

  return { posting, isError, isOk };
};

export { useOfferStats, useOfferAcceptedDrivers, usePostSelectedDrivers };
